import { useMemo, useState } from 'react'
import useSessionStore from 'Context/useSessionStore'
import SearchableListButton from 'Organisms/SearchableListButton'
import { LIST_ROLE_FILTER_USER } from './roleFilterOptions'

const RoleFilterDropdown = ({ onFilter }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))

  const roleSwitches = useMemo(
    () =>
      LIST_ROLE_FILTER_USER.options
        .filter((role) => !role.allowed || role.allowed.some((allowedRole) => allowedRole === user.role))
        .map((role) => ({ id: `${LIST_ROLE_FILTER_USER.header}${role.option}`, text: role.option, checked: false })),
    [user.role]
  )

  const [switches, setSwitches] = useState(roleSwitches)

  const handleChangeSwitches = ({ values }) => {
    setSwitches(values)

    onFilter({
      result: { [LIST_ROLE_FILTER_USER.header]: values.filter((role) => role.checked).map((role) => role.text) }
    })
  }

  return (
    <SearchableListButton
      id="filterRole"
      name={LIST_ROLE_FILTER_USER.header}
      switches={switches}
      setSwitches={handleChangeSwitches}
      hiddenSearch
    />
  )
}

export default RoleFilterDropdown
